"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[63],{

/***/ 74455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useGatedBySlug; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var use_persisted_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80169);


var useGatedBySlug = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    return (0,use_persisted_state__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(router.route)(true);
};


/***/ }),

/***/ 91143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useRefScrollProgress; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function useRefScrollProgress(param) {
    var _offset = param.offset, offset = _offset === void 0 ? 0 : _offset;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), start = ref1[0], setStart = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), end = ref2[0], setEnd = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!ref.current) {
            return;
        }
        var rect = ref.current.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var offsetTop = rect.top + scrollTop;
        setStart(offsetTop / document.body.clientHeight + offset);
        setEnd((offsetTop + rect.height) / document.body.clientHeight + offset);
    }, [
        offset,
        ref,
        setStart
    ]);
    return {
        ref: ref,
        start: start,
        end: end
    };
}


/***/ }),

/***/ 72849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70205);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var Form = (0,formik__WEBPACK_IMPORTED_MODULE_1__/* .connect */ .$j)(function(_param) /*#__PURE__*/ {
    var _formik = _param.formik, handleReset = _formik.handleReset, handleSubmit = _formik.handleSubmit, props = _objectWithoutProperties(_param, [
        "formik"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", _objectSpread({
        onReset: handleReset,
        onSubmit: handleSubmit,
        noValidate: true
    }, props));
});
/** Formik-connected form. */ 
Form.displayName = "Form";


/***/ }),

/***/ 25017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ExternalLink; },
/* harmony export */   "h": function() { return /* binding */ InternalLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _air_marketing_analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64043);
/* harmony import */ var _air_zephyr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55164);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82740);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







/** @comment do not export this component */ var Anchor = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.forwardRef)(function(_param, ref) {
    var analytics = _param.analytics, onClick = _param.onClick, tx = _param.tx, restOfProps = _objectWithoutProperties(_param, [
        "analytics",
        "onClick",
        "tx"
    ]);
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .useTheme */ .Fg)();
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().asPath;
    var trackClickedActionItem = (0,_air_marketing_analytics__WEBPACK_IMPORTED_MODULE_1__/* .useTrackClickedActionItem */ .Nw)().trackClickedActionItem;
    var onLinkClick = function(event) {
        if (onClick) onClick(event);
        trackClickedActionItem(_objectSpread({
            location: window.location.href,
            pathName: asPath,
            zone: "marketing"
        }, analytics));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_air_zephyr__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, _objectSpread({
        as: "a",
        ref: ref,
        onClick: onLinkClick
    }, restOfProps, {
        tx: _objectSpread({
            borderRadius: 4,
            color: "jay500",
            fontFamily: "copy",
            fontSize: 16,
            fontWeight: "semibold",
            lineHeight: 1.5,
            letterSpacing: "2%",
            wordBreak: "break-word",
            textDecoration: "none",
            cursor: "pointer",
            "&:focus, &:hover": {
                textDecoration: "underline"
            },
            "&:focus": {
                outline: "none"
            },
            "&:focus-visible": {
                boxShadow: "0 0 0 2px ".concat(theme.colors.macaw100)
            }
        }, tx)
    }));
});
Anchor.displayName = "Anchor";
var ExternalLink = function(_param) {
    var analytics = _param.analytics, href = _param.href, _rel = _param.rel, rel = _rel === void 0 ? "noopener noreferrer" : _rel, _target = _param.target, target = _target === void 0 ? "_blank" : _target, restOfProps = _objectWithoutProperties(_param, [
        "analytics",
        "href",
        "rel",
        "target"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anchor, _objectSpread({
        href: href,
        analytics: _objectSpread({
            destination: href,
            destinationType: "external"
        }, analytics),
        rel: rel,
        target: target
    }, restOfProps));
};

var InternalLink = function(_param) {
    var analytics = _param.analytics, as = _param.as, children = _param.children, href = _param.href, _passHref = _param.passHref, passHref = _passHref === void 0 ? true : _passHref, _prefetch = _param.prefetch, prefetch = _prefetch === void 0 ? undefined : _prefetch, _replace = _param.replace, replace = _replace === void 0 ? false : _replace, _scroll = _param.scroll, scroll = _scroll === void 0 ? true : _scroll, _shallow = _param.shallow, shallow = _shallow === void 0 ? false : _shallow, restOfProps = _objectWithoutProperties(_param, [
        "analytics",
        "as",
        "children",
        "href",
        "passHref",
        "prefetch",
        "replace",
        "scroll",
        "shallow"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        as: as,
        href: href,
        passHref: passHref,
        prefetch: prefetch,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anchor, _objectSpread({
            analytics: _objectSpread({
                destination: as || href,
                destinationType: "external"
            }, analytics)
        }, restOfProps, {
            children: children
        }))
    });
};



/***/ }),

/***/ 32999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Section; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _air_marketing_analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64043);
/* harmony import */ var _air_zephyr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55164);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42708);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var Section = function(_param) {
    var analytics = _param.analytics, children = _param.children, index = _param.index, onInView = _param.onInView, _threshold = _param.threshold, threshold = _threshold === void 0 ? 0 : _threshold, _triggerOnce = _param.triggerOnce, triggerOnce = _triggerOnce === void 0 ? true : _triggerOnce, tx = _param.tx, restOfProps = _objectWithoutProperties(_param, [
        "analytics",
        "children",
        "index",
        "onInView",
        "threshold",
        "triggerOnce",
        "tx"
    ]);
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().asPath;
    var trackViewedMarketingSection = (0,_air_marketing_analytics__WEBPACK_IMPORTED_MODULE_1__/* .useTrackViewedMarketingSection */ .o4)().trackViewedMarketingSection;
    var onChange = function(inView, entry) {
        if (inView) {
            trackViewedMarketingSection(_objectSpread({
                location: window.location.href,
                order: index,
                pathName: asPath
            }, analytics));
        }
        if (onInView) {
            onInView(inView, entry);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__/* .InView */ .df, {
        as: "section",
        onChange: onChange,
        threshold: threshold,
        triggerOnce: triggerOnce,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_air_zephyr__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, _objectSpread({}, restOfProps, {
            tx: _objectSpread({
                zIndex: 0,
                position: "relative",
                py: [
                    64,
                    64,
                    80
                ],
                overflow: "hidden"
            }, tx),
            children: children
        }))
    });
};



/***/ }),

/***/ 31548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ SECTION_CMS_LINK_CLASS_NAME; },
  "$": function() { return /* binding */ Section; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@air/icons/dist/icons.esm.js
var icons_esm = __webpack_require__(74398);
// EXTERNAL MODULE: ../../node_modules/@air/zephyr/dist/zephyr.esm.js + 90 modules
var zephyr_esm = __webpack_require__(55164);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
// EXTERNAL MODULE: ../../packages/primitives/src/index.tsx + 20 modules
var src = __webpack_require__(89170);
;// CONCATENATED MODULE: ./src/old-marketing/components/sections/Section.styles.ts

var SECTION_ELEMENT_TAG = "section";
var Root = (0,src/* styled */.zo)(SECTION_ELEMENT_TAG, {
    zIndex: 1,
    position: "relative",
    boxSizing: "border-box",
    overflow: "hidden"
});
var PreviewLabel = (0,src/* styled */.zo)(src/* Text */.xv, {
    zIndex: 1,
    position: "absolute",
    top: 0,
    left: 0,
    backgroundColor: "$macaw200",
    borderBottomRightRadius: 4,
    paddingY: 4,
    paddingX: 8,
    color: "$white",
    fontWeight: "semibold"
});
PreviewLabel.defaultProps = {
    size: "ui-12",
    transform: "uppercase"
};
var PreviewLabelLink = (0,src/* styled */.zo)("a", {
    display: "flex",
    alignItems: "center",
    color: "inherit",
    fontSize: "inherit",
    textDecoration: "none"
});
PreviewLabelLink.defaultProps = {
    target: "_blank"
};

// EXTERNAL MODULE: ./src/providers/PreviewModeProvider.tsx
var PreviewModeProvider = __webpack_require__(71119);
// EXTERNAL MODULE: ./src/utils/getContentfulUrl.ts
var getContentfulUrl = __webpack_require__(86250);
;// CONCATENATED MODULE: ./src/old-marketing/components/sections/Section.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var SECTION_CMS_LINK_CLASS_NAME = "is-cms-linked";
var Section = function(_param) {
    var children = _param.children, css = _param.css, id = _param.id, onInViewChange = _param.onInViewChange, templateKey = _param.templateKey, threshold = _param.threshold, triggerOnce = _param.triggerOnce, restOfProps = _objectWithoutProperties(_param, [
        "children",
        "css",
        "id",
        "onInViewChange",
        "templateKey",
        "threshold",
        "triggerOnce"
    ]);
    var isPreview = (0,PreviewModeProvider/* usePreviewMode */.s)().isPreview;
    var contentfulUrl = (0,getContentfulUrl/* getContentfulUrl */.H)(id);
    if (onInViewChange) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer/* InView */.df, {
            as: "section",
            id: id,
            onChange: onInViewChange,
            threshold: threshold,
            triggerOnce: triggerOnce,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, _objectSpread({
                css: _objectSpread({
                    boxShadow: isPreview ? "inset 0 0 0 2px $colors$macaw200" : undefined,
                    "&:hover": _defineProperty({}, "& .".concat(SECTION_CMS_LINK_CLASS_NAME), {
                        boxShadow: "0 0 0 2px $colors$macaw200"
                    })
                }, css)
            }, restOfProps, {
                children: [
                    isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewLabel, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewLabelLink, {
                            href: contentfulUrl,
                            children: templateKey
                        })
                    }),
                    children
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, _objectSpread({
        as: "section",
        id: id,
        css: _objectSpread({
            boxShadow: isPreview ? "inset 0 0 0 2px $colors$macaw200" : undefined,
            "&:hover": _defineProperty({}, "& .".concat(SECTION_CMS_LINK_CLASS_NAME), {
                boxShadow: "0 0 0 2px $colors$macaw200"
            })
        }, css)
    }, restOfProps, {
        children: [
            isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewLabel, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PreviewLabelLink, {
                    href: contentfulUrl,
                    children: [
                        templateKey,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                            as: icons_esm/* GoTo */.IyC,
                            tx: {
                                display: "block",
                                width: 12,
                                ml: 4
                            }
                        })
                    ]
                })
            }),
            children
        ]
    }));
};

Section.toString = function() {
    return "".concat(Root.className);
};


/***/ }),

/***/ 84269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZG": function() { return /* binding */ SectionContent; }
});

// UNUSED EXPORTS: TEXT_SIZE_CSS, TEXT_SIZE_VARIANTS

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/primitives/src/index.tsx + 20 modules
var src = __webpack_require__(89170);
// EXTERNAL MODULE: ./src/old-marketing/components/sections/Section.tsx + 1 modules
var Section = __webpack_require__(31548);
// EXTERNAL MODULE: ./src/old-marketing/components/sections/SectionFieldTooltip.tsx
var SectionFieldTooltip = __webpack_require__(83021);
// EXTERNAL MODULE: ../../node_modules/@air/zephyr/dist/zephyr.esm.js + 90 modules
var zephyr_esm = __webpack_require__(55164);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-plain-text-renderer/dist/rich-text-plain-text-renderer.es5.js
var rich_text_plain_text_renderer_es5 = __webpack_require__(22589);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(20204);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
// EXTERNAL MODULE: ./src/old-marketing/components/Link.tsx
var Link = __webpack_require__(25017);
;// CONCATENATED MODULE: ./src/old-marketing/components/richText/Bold.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var Bold = function(_param) {
    var tx = _param.tx, restOfProps = _objectWithoutProperties(_param, [
        "tx"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, _objectSpread({
        as: "strong"
    }, restOfProps, {
        tx: _objectSpread({
            fontWeight: "semibold"
        }, tx)
    }));
};


;// CONCATENATED MODULE: ./src/old-marketing/components/richText/Italic.tsx
function Italic_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Italic_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Italic_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Italic_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Italic_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Italic_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var Italic = function(_param) {
    var tx = _param.tx, restOfProps = Italic_objectWithoutProperties(_param, [
        "tx"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, Italic_objectSpread({
        as: "i"
    }, restOfProps, {
        tx: Italic_objectSpread({
            color: "inherit",
            fontFamily: "inherit",
            fontSize: "inherit",
            fontStyle: "italic"
        }, tx)
    }));
};


;// CONCATENATED MODULE: ./src/old-marketing/components/richText/List.tsx
function List_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function List_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            List_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function List_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = List_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function List_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var ListItem = function(_param) {
    var tx = _param.tx, restOfProps = List_objectWithoutProperties(_param, [
        "tx"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, List_objectSpread({
        as: "li"
    }, restOfProps, {
        tx: List_objectSpread({
            mb: 8
        }, tx)
    }));
};

var OrderedList = function(_param) {
    var tx = _param.tx, restOfProps = List_objectWithoutProperties(_param, [
        "tx"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, List_objectSpread({
        as: "ol"
    }, restOfProps, {
        tx: List_objectSpread({
            pl: 24
        }, tx)
    }));
};

var UnorderedList = function(_param) {
    var tx = _param.tx, restOfProps = List_objectWithoutProperties(_param, [
        "tx"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, List_objectSpread({
        as: "ul"
    }, restOfProps, {
        tx: List_objectSpread({
            pl: 24
        }, tx)
    }));
};


;// CONCATENATED MODULE: ./src/old-marketing/components/richText/Underline.tsx
function Underline_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Underline_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Underline_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Underline_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Underline_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Underline_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var Underline = function(_param) {
    var tx = _param.tx, restOfProps = Underline_objectWithoutProperties(_param, [
        "tx"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, Underline_objectSpread({
        as: "u"
    }, restOfProps, {
        tx: Underline_objectSpread({
            textDecoration: "underline"
        }, tx)
    }));
};

var Squiggly = function() {
    return /*#__PURE__*/ _jsxs("svg", {
        height: "5",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            zIndex: -1,
            position: "absolute",
            bottom: 0,
            width: "100%",
            left: 0
        },
        children: [
            /*#__PURE__*/ _jsx("pattern", {
                id: "squiggly",
                x: "0",
                y: "0",
                width: "78",
                height: "5",
                patternUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M0 1.67188C10.5043 1.67188 10.5043 3.03799 19.8895 3.03799C29.2747 3.03799 29.2747 1.67188 38.6622 1.67188C48.0496 1.67188 48.0496 3.03799 57.4348 3.03799C66.82 3.03799 66.8223 1.67188 78.2075 1.67188",
                    stroke: "#33DBDB",
                    strokeWidth: "2",
                    strokeMiterlimit: "10",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "0",
                y: "0",
                width: "100%",
                height: "100%",
                fill: "url(#squiggly)"
            })
        ]
    });
};
var SquigglyUnderline = function(_param) {
    var children = _param.children, tx = _param.tx, restOfProps = Underline_objectWithoutProperties(_param, [
        "children",
        "tx"
    ]);
    return /*#__PURE__*/ _jsxs(Box, Underline_objectSpread({
        as: "u"
    }, restOfProps, {
        tx: Underline_objectSpread({
            zIndex: 1,
            position: "relative",
            textDecoration: "none"
        }, tx),
        children: [
            children,
            /*#__PURE__*/ _jsx(Squiggly, {})
        ]
    }));
};


;// CONCATENATED MODULE: ./src/old-marketing/utils/textRenderer.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function textRenderer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function textRenderer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            textRenderer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var richTextRenderer = function(content, customOptions) {
    var renderText = function(text) {
        return text.split("\n").reduce(function(children, textSegment, index) {
            return _toConsumableArray(children).concat([
                index > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    as: "br"
                }, index),
                textSegment
            ]);
        }, []);
    };
    var ref;
    var _obj, _obj1;
    return (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(content, {
        /* eslint-disable react/display-name */ renderMark: textRenderer_objectSpread((_obj = {}, textRenderer_defineProperty(_obj, dist.MARKS.BOLD, function(text) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bold, {
                children: text
            });
        }), textRenderer_defineProperty(_obj, dist.MARKS.ITALIC, function(text) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Italic, {
                children: text
            });
        }), textRenderer_defineProperty(_obj, dist.MARKS.UNDERLINE, function(text) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Underline, {
                children: text
            });
        }), _obj), customOptions === null || customOptions === void 0 ? void 0 : customOptions.renderMark),
        renderNode: textRenderer_objectSpread((_obj1 = {}, textRenderer_defineProperty(_obj1, dist.BLOCKS.HEADING_2, function(_, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                as: "h2",
                variant: [
                    "text-heading-32",
                    "text-heading-32",
                    "text-heading-40"
                ],
                tx: {
                    color: "jay700",
                    mt: [
                        48,
                        48,
                        60
                    ],
                    mb: [
                        24,
                        24,
                        16
                    ]
                },
                children: children
            });
        }), textRenderer_defineProperty(_obj1, dist.BLOCKS.LIST_ITEM, function(_, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                children: children
            });
        }), textRenderer_defineProperty(_obj1, dist.BLOCKS.OL_LIST, function(_, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderedList, {
                children: children
            });
        }), textRenderer_defineProperty(_obj1, dist.BLOCKS.PARAGRAPH, function(_, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                as: "p",
                tx: {
                    mb: 24,
                    color: "inherit",
                    fontFamily: "inherit",
                    fontSize: "inherit",
                    lineHeight: "inherit",
                    letterSpacing: "inherit",
                    "&:last-child": {
                        mb: 0
                    }
                },
                children: children
            });
        }), textRenderer_defineProperty(_obj1, dist.BLOCKS.UL_LIST, function(_, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(UnorderedList, {
                children: children
            });
        }), textRenderer_defineProperty(_obj1, dist.INLINES.HYPERLINK, function(node, children) {
            var uri = (node === null || node === void 0 ? void 0 : node.data).uri;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* ExternalLink */.d, {
                href: uri,
                tx: {
                    display: "inline",
                    fontSize: "inherit"
                },
                children: children
            });
        }), _obj1), customOptions === null || customOptions === void 0 ? void 0 : customOptions.renderNode),
        /* eslint-enable react/display-name */ renderText: (ref = customOptions === null || customOptions === void 0 ? void 0 : customOptions.renderText) !== null && ref !== void 0 ? ref : renderText
    });
};
var planTextRenderer = function(content) {
    return documentToPlainTextString(content);
};

// EXTERNAL MODULE: ./src/providers/PreviewModeProvider.tsx
var PreviewModeProvider = __webpack_require__(71119);
// EXTERNAL MODULE: ./src/utils/clamp.ts + 1 modules
var clamp = __webpack_require__(5808);
;// CONCATENATED MODULE: ./src/old-marketing/components/sections/SectionContent.tsx
function SectionContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SectionContent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SectionContent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var TEXT_SIZE_CSS = {
    "ui-20": {
        fontSize: (0,clamp/* clamp */.u)(16, 20)
    },
    "ui-18": {
        fontSize: (0,clamp/* clamp */.u)(16, 20)
    }
};
var TEXT_SIZE_VARIANTS = {
    "ui-20": {
        desktop: "ui-20",
        mobile: "ui-16"
    },
    "ui-18": {
        desktop: "ui-18",
        mobile: "ui-16"
    }
};
var SectionContent = function(param) {
    var children = param.children, css = param.css, content = param.content, contentMapping = param.contentMapping, _isCMSLinked = param.isCMSLinked, isCMSLinked = _isCMSLinked === void 0 ? true : _isCMSLinked, _size = param.size, size = _size === void 0 ? "ui-20" : _size;
    var isPreview = (0,PreviewModeProvider/* usePreviewMode */.s)().isPreview;
    var element = /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Text */.xv, {
        className: isPreview && isCMSLinked ? Section/* SECTION_CMS_LINK_CLASS_NAME */.l : "",
        css: SectionContent_objectSpread({}, TEXT_SIZE_CSS[size], css),
        size: {
            "@initial": TEXT_SIZE_VARIANTS[size].mobile,
            "@desktop": TEXT_SIZE_VARIANTS[size].desktop
        },
        children: content ? richTextRenderer(content, contentMapping) : children
    });
    return isCMSLinked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFieldTooltip/* SectionFieldTooltip */.B, {
        field: "Content",
        children: element
    }) : element;
};


/***/ }),

/***/ 83021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ SectionFieldTooltip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _air_zephyr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55164);
/* harmony import */ var _providers_PreviewModeProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71119);



var SectionFieldTooltip = function(param) {
    var children = param.children, field = param.field;
    var isPreview = (0,_providers_PreviewModeProvider__WEBPACK_IMPORTED_MODULE_2__/* .usePreviewMode */ .s)().isPreview;
    if (!isPreview) {
        return children;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_air_zephyr__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
        label: "Contentful Field: ".concat(field),
        side: "top",
        children: children
    });
};


/***/ }),

/***/ 5811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _air_marketing_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89170);
/* harmony import */ var _old_marketing_components_sections_Section__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31548);
/* harmony import */ var _old_marketing_components_sections_SectionFieldTooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83021);
/* harmony import */ var _providers_PreviewModeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71119);
/* harmony import */ var _utils_clamp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5808);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var TEXT_SIZE_CSS = {
    "heading-72": {
        fontSize: (0,_utils_clamp__WEBPACK_IMPORTED_MODULE_5__/* .clamp */ .u)(40, 72)
    },
    "heading-64": {
        fontSize: (0,_utils_clamp__WEBPACK_IMPORTED_MODULE_5__/* .clamp */ .u)(40, 64)
    },
    "heading-56": {
        fontSize: (0,_utils_clamp__WEBPACK_IMPORTED_MODULE_5__/* .clamp */ .u)(40, 56)
    },
    "heading-48": {
        fontSize: (0,_utils_clamp__WEBPACK_IMPORTED_MODULE_5__/* .clamp */ .u)(32, 48)
    },
    "heading-40": {
        fontSize: (0,_utils_clamp__WEBPACK_IMPORTED_MODULE_5__/* .clamp */ .u)(32, 40)
    },
    "heading-32": {
        fontSize: (0,_utils_clamp__WEBPACK_IMPORTED_MODULE_5__/* .clamp */ .u)(28, 32)
    },
    "heading-28": {
        fontSize: (0,_utils_clamp__WEBPACK_IMPORTED_MODULE_5__/* .clamp */ .u)(24, 28)
    },
    "heading-24": {
        fontSize: (0,_utils_clamp__WEBPACK_IMPORTED_MODULE_5__/* .clamp */ .u)(20, 24)
    }
};
var TEXT_SIZE_VARIANTS = {
    "heading-72": {
        desktop: "heading-72",
        mobile: "heading-40"
    },
    "heading-64": {
        desktop: "heading-64",
        mobile: "heading-40"
    },
    "heading-56": {
        desktop: "heading-56",
        mobile: "heading-40"
    },
    "heading-48": {
        desktop: "heading-48",
        mobile: "heading-32"
    },
    "heading-40": {
        desktop: "heading-40",
        mobile: "heading-32"
    },
    "heading-32": {
        desktop: "heading-32",
        mobile: "heading-28"
    },
    "heading-28": {
        desktop: "heading-28",
        mobile: "heading-24"
    },
    "heading-24": {
        desktop: "heading-24",
        mobile: "heading-20"
    }
};
var SectionTitle = function(param) {
    var as = param.as, children = param.children, css = param.css, dangerouslySetInnerHTML = param.dangerouslySetInnerHTML, _isCMSLinked = param.isCMSLinked, isCMSLinked = _isCMSLinked === void 0 ? true : _isCMSLinked, _isSubsection = param.isSubsection, isSubsection = _isSubsection === void 0 ? false : _isSubsection, _size = param.size, size = _size === void 0 ? "heading-48" : _size;
    var isPreview = (0,_providers_PreviewModeProvider__WEBPACK_IMPORTED_MODULE_4__/* .usePreviewMode */ .s)().isPreview;
    var element = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_air_marketing_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
        as: (as !== null && as !== void 0 ? as : isSubsection) ? "h3" : "h2",
        className: isPreview && isCMSLinked ? _old_marketing_components_sections_Section__WEBPACK_IMPORTED_MODULE_2__/* .SECTION_CMS_LINK_CLASS_NAME */ .l : "",
        css: _objectSpread({
            fontWeight: "$semibold"
        }, TEXT_SIZE_CSS[size], css),
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        size: {
            "@initial": TEXT_SIZE_VARIANTS[size].mobile,
            "@desktop": TEXT_SIZE_VARIANTS[size].desktop
        },
        children: children
    });
    return isCMSLinked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_old_marketing_components_sections_SectionFieldTooltip__WEBPACK_IMPORTED_MODULE_3__/* .SectionFieldTooltip */ .B, {
        field: "Title",
        children: element
    }) : element;
};


/***/ }),

/***/ 47016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ worthlessStudiosTheme; }
/* harmony export */ });
/* harmony import */ var _air_marketing_primitives__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89170);

var worthlessStudiosTheme = (0,_air_marketing_primitives__WEBPACK_IMPORTED_MODULE_0__/* .createTheme */ .jG)("worthless-studios-theme", {
    fonts: {
        copy: 'Menlo, Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        display: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        monospace: 'Menlo, Consolas, Roboto Mono, "Ubuntu Monospace", "Noto Mono", "Oxygen Mono", "Liberation Mono", monospace'
    }
});


/***/ }),

/***/ 78214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ buttonLinkRenderer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _air_marketing_analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64043);
/* harmony import */ var _air_marketing_tech_debt_src_components_dialogs_DemoDialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46445);
/* harmony import */ var _air_zephyr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55164);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76635);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2784);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








/**
 * This component is used for the `buttonLinkRenderer` and should not be used outside of the scope of the function.
 * Do not export this component.
 */ var ButtonLink = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_7__.forwardRef)(function(_param, ref) {
    var analytics = _param.analytics, children = _param.children, onClick = _param.onClick, href = _param.href, type = _param.type, tx = _param.tx, restOfProps = _objectWithoutProperties(_param, [
        "analytics",
        "children",
        "onClick",
        "href",
        "type",
        "tx"
    ]);
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), isDialogOpened = _$ref[0], setIsDialogOpened = _$ref[1];
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)().asPath;
    var trackClickedActionItem = (0,_air_marketing_analytics__WEBPACK_IMPORTED_MODULE_1__/* .useTrackClickedActionItem */ .Nw)().trackClickedActionItem;
    var isDemoDialog = href === null || href === void 0 ? void 0 : href.includes("#demo");
    var onButtonClick = function(event) {
        if (onClick) onClick(event);
        trackClickedActionItem(_objectSpread({
            destination: href,
            destinationType: type,
            location: window.location.href,
            pathName: asPath,
            zone: "marketing"
        }, analytics));
    };
    if (isDemoDialog) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_air_marketing_tech_debt_src_components_dialogs_DemoDialog__WEBPACK_IMPORTED_MODULE_2__/* .DemoDialog */ .d, {
                    isOpen: isDialogOpened,
                    onDismiss: function() {
                        setIsDialogOpened(false);
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_air_zephyr__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, _objectSpread({
                    as: "a",
                    onClick: function(event) {
                        event.preventDefault();
                        onButtonClick(event);
                        setIsDialogOpened(true);
                    },
                    href: href,
                    ref: ref,
                    tx: _objectSpread({}, tx)
                }, restOfProps, {
                    children: children
                }))
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_air_zephyr__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, _objectSpread({
        as: "a",
        href: href,
        onClick: onButtonClick,
        ref: ref,
        tx: _objectSpread({}, tx, {
            "-webkit-appearance": "none"
        })
    }, restOfProps, {
        children: children
    }));
});
ButtonLink.displayName = "ButtonLink";
var buttonLinkRenderer = function(_param) {
    var id = _param.id, href = _param.href, _onClick = _param.onClick, onClick = _onClick === void 0 ? lodash__WEBPACK_IMPORTED_MODULE_4__.noop : _onClick, type = _param.type, restOfProps = _objectWithoutProperties(_param, [
        "id",
        "href",
        "onClick",
        "type"
    ]);
    var isIntercom = href.includes("#intercom");
    var isExternalUrl = type === "external";
    /**
   * Intercom button events are managed through the Intercom dashboard
   */ if (isIntercom) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_air_zephyr__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, _objectSpread({
            className: "intercom-button",
            id: "intercom-button-".concat(id),
            onClick: onClick,
            type: "button"
        }, restOfProps), id);
    }
    if (isExternalUrl) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLink, _objectSpread({
            href: href,
            onClick: onClick,
            type: type
        }, restOfProps, {
            rel: "noopener noreferrer",
            target: "_blank"
        }), id);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLink, _objectSpread({
            type: type
        }, restOfProps))
    }, id);
};



/***/ }),

/***/ 68063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ sectionRenderer; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/lib/contentful/constants/contentTypes.ts
var ContentTypes = {
    components: {
        button: "componentButton",
        link: "componentLink",
        video: "componentVideo"
    },
    hero: {
        comparisonDynamic: "comparisonPageHero",
        enterprise: "enterprisePageHero",
        pricing: "pricingPageHero",
        text: "heroText",
        textWithVideo: "heroTextWithVideo"
    },
    page: "page",
    sections: {
        shared: {
            blogPosts: "sectionBlogPosts",
            blurbs: "sectionBlurbs",
            brands: "sectionBrands",
            callToAction: "commonCallToAction",
            customerQuote: "commonCustomer",
            customers: "sectionCustomers",
            group: "sectionGroup",
            pageCards: "sectionPageCards",
            questions: "sectionQuestions",
            tagline: "sectionTagline",
            text: "sectionText",
            textWithAssets: "sectionTextWithAssets",
            textWithImage: "sectionTextWithImage",
            textWithMultipleImages: "sectionTextWithMultipleImages",
            textWithTimeline: "sectionTextWithTimeline"
        },
        legal: {
            text: "sectionLegalText"
        },
        pricing: {
            oldFaq: "pricingPageFaq",
            oldFeatureComparison: "pricingPageFeatureComparison"
        },
        productTour: {
            generic: "productTourGeneric",
            references: "productTourReference",
            tools: "productTourTools"
        },
        about: {
            distributedTeam: "aboutPageDistributedTeam",
            summary: "aboutPageSummary"
        },
        comparison: {
            generic: "comparisonPageGeneric"
        },
        home: {
            brands: "homePageBrands",
            customer: "commonCustomer",
            generic: "homePageGeneric",
            productTour: "homePageProductTour",
            productOverview: "homePageProductOverview"
        }
    }
};

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@air/zephyr/dist/zephyr.esm.js + 90 modules
var zephyr_esm = __webpack_require__(55164);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/framer-motion.es.js + 37 modules
var framer_motion_es = __webpack_require__(77665);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
;// CONCATENATED MODULE: ./src/old-marketing/components/Video.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var Video = function(_param) {
    var _autoPlay = _param.autoPlay, autoPlay = _autoPlay === void 0 ? true : _autoPlay, details = _param.details, _loop = _param.loop, loop = _loop === void 0 ? true : _loop, _muted = _param.muted, muted = _muted === void 0 ? true : _muted, _playsInline = _param.playsInline, playsInline = _playsInline === void 0 ? true : _playsInline, _preload = _param.preload, preload = _preload === void 0 ? "none" : _preload, poster = _param.poster, sources = _param.sources, tx = _param.tx, restOfProps = _objectWithoutProperties(_param, [
        "autoPlay",
        "details",
        "loop",
        "muted",
        "playsInline",
        "preload",
        "poster",
        "sources",
        "tx"
    ]);
    var videoRef = (0,react.useRef)(null);
    var ref5 = _slicedToArray((0,react_intersection_observer/* useInView */.YD)(), 2), ref1 = ref5[0], inView = ref5[1];
    var ref2 = (0,react.useState)(false), hasLoadedOnce = ref2[0], setHasLoadedOnce = ref2[1];
    var shouldReduceMotion = (0,framer_motion_es/* useReducedMotion */.JZ)();
    (0,react.useEffect)(function() {
        if (shouldReduceMotion) return;
        if (inView && !hasLoadedOnce) {
            var ref;
            videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.load();
            setHasLoadedOnce(true);
        } else if (inView) {
            var ref3;
            videoRef === null || videoRef === void 0 ? void 0 : (ref3 = videoRef.current) === null || ref3 === void 0 ? void 0 : ref3.play();
        } else if (hasLoadedOnce && loop) {
            var ref4;
            videoRef === null || videoRef === void 0 ? void 0 : (ref4 = videoRef.current) === null || ref4 === void 0 ? void 0 : ref4.pause();
        }
    }, [
        hasLoadedOnce,
        inView,
        loop,
        shouldReduceMotion,
        videoRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, _objectSpread({
        tx: _objectSpread({
            position: "relative"
        }, tx),
        style: {
            paddingBottom: details && details.height && details.width && "".concat(details.height / details.width * 100, "%")
        },
        ref: ref1
    }, restOfProps, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
            as: "video",
            autoPlay: autoPlay,
            playsInline: playsInline,
            loop: loop,
            muted: muted,
            poster: inView ? poster : "",
            preload: preload,
            ref: videoRef,
            tx: {
                /**
           * This is to prevent the video from have a stretching on initial load.
           * @see https://stackoverflow.com/a/39668112
           */ objectFit: "fill",
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%"
            },
            children: sources === null || sources === void 0 ? void 0 : sources.map(function(source) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    as: "source",
                    src: inView ? source.src : undefined,
                    type: source.type
                }, "".concat(source.type, "-").concat(source.src));
            })
        }, sources === null || sources === void 0 ? void 0 : sources.map(function(source) {
            return source === null || source === void 0 ? void 0 : source.src;
        }).join("-"))
    }));
};


// EXTERNAL MODULE: ./src/old-marketing/components/Container.tsx + 1 modules
var Container = __webpack_require__(29654);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../packages/analytics/src/index.ts + 42 modules
var src = __webpack_require__(64043);
// EXTERNAL MODULE: ../../packages/plasmic-chilipiper/src/index.ts + 7 modules
var plasmic_chilipiper_src = __webpack_require__(56111);
// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 109 modules
var formik_esm = __webpack_require__(70205);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(24511);
// EXTERNAL MODULE: ./src/old-marketing/components/Form.tsx
var Form = __webpack_require__(72849);
;// CONCATENATED MODULE: ./src/old-marketing/components/forms/AdobeWaitlistForm.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function AdobeWaitlistForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AdobeWaitlistForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AdobeWaitlistForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var validationSchema = (0,es/* object */.Ry)({
    email: plasmic_chilipiper_src/* chilipiperEmailValidationSchema */.qm
});
var addToSpreadsheet = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values) {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("https://sheetdb.io/api/v1/q0uukn89582fl", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(values)
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.json());
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function addToSpreadsheet(values) {
        return _ref.apply(this, arguments);
    };
}();
var AdobeWaitlistForm = function(param1) {
    var tx = param1.tx;
    var ref = (0,react.useState)(false), hasSubmitted = ref[0], setHasSubmitted = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: validationSchema.cast(undefined),
        onSubmit: function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values) {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return addToSpreadsheet(AdobeWaitlistForm_objectSpread({}, values, {
                                type: "Adobe Premiere Pro"
                            }));
                        case 2:
                            response = _ctx.sent;
                            if (response.created === 1) {
                                setHasSubmitted(true);
                            }
                            (0,src/* trackGTMEvent */.dG)({
                                event: "Adobe Waitlist",
                                eventProps: {
                                    label: "adobe waitlist",
                                    category: "gated"
                                }
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }(),
        validationSchema: validationSchema,
        children: function(param) {
            var isSubmitting = param.isSubmitting;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                    tx: AdobeWaitlistForm_objectSpread({
                        display: "flex",
                        flexDirection: [
                            "column",
                            "row"
                        ],
                        alignItems: "center"
                    }, tx),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Input */.II, {
                            autoComplete: "email",
                            disabled: hasSubmitted,
                            isLabelHidden: true,
                            label: "Email",
                            name: "email",
                            placeholder: "Enter your work email",
                            required: true,
                            tx: {
                                flexGrow: 1,
                                minWidth: "unset",
                                width: [
                                    "100%",
                                    "auto"
                                ]
                            },
                            type: "email",
                            variant: "field-input-chonky"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Button */.zx, {
                            disabled: hasSubmitted,
                            isLoading: isSubmitting,
                            size: "large",
                            type: "submit",
                            tx: {
                                width: [
                                    "100%",
                                    "auto"
                                ],
                                mt: [
                                    16,
                                    0
                                ],
                                ml: [
                                    0,
                                    16
                                ]
                            },
                            children: hasSubmitted ? "Success!" : "Join the waitlist"
                        })
                    ]
                })
            });
        }
    });
};

// EXTERNAL MODULE: ./src/old-marketing/components/sections/Section.tsx + 1 modules
var Section = __webpack_require__(31548);
// EXTERNAL MODULE: ./src/old-marketing/components/sections/SectionContent.tsx + 5 modules
var SectionContent = __webpack_require__(84269);
// EXTERNAL MODULE: ./src/old-marketing/components/sections/SectionFieldTooltip.tsx
var SectionFieldTooltip = __webpack_require__(83021);
// EXTERNAL MODULE: ./src/old-marketing/components/sections/SectionTitle.tsx
var SectionTitle = __webpack_require__(5811);
// EXTERNAL MODULE: ./src/providers/PreviewModeProvider.tsx
var PreviewModeProvider = __webpack_require__(71119);
;// CONCATENATED MODULE: ./src/old-marketing/components/sections/templates/AdobeSplashCTASectionTemplate.tsx










var TEMPLATE_KEY = "adobe-splash-cta";
var AdobeSplashCTASectionTemplate = function(param) {
    var content = param.content, isSubsection = param.isSubsection, id = param.id, title = param.title, videos = param.videos;
    var isPreview = (0,PreviewModeProvider/* usePreviewMode */.s)().isPreview;
    var video = videos === null || videos === void 0 ? void 0 : videos[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
        css: {
            position: "relative",
            paddingTop: 0,
            paddingBottom: 156
        },
        id: id,
        templateKey: TEMPLATE_KEY,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                    tx: {
                        maxWidth: 760,
                        mx: "auto",
                        textAlign: "center"
                    },
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                            css: {
                                marginBottom: 36,
                                color: "$jay150"
                            },
                            isSubsection: isSubsection,
                            size: "heading-56",
                            children: title
                        }),
                        content && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContent/* SectionContent */.ZG, {
                            content: content,
                            css: {
                                marginBottom: 48,
                                color: "$pigeon200"
                            },
                            size: "ui-20"
                        })
                    ]
                }),
                video && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFieldTooltip/* SectionFieldTooltip */.B, {
                    field: "Videos",
                    isPreview: isPreview,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
                            className: isPreview ? Section/* SECTION_CMS_LINK_CLASS_NAME */.l : "",
                            details: {
                                height: video.height,
                                width: video.width
                            },
                            poster: video.poster.file.url,
                            sources: video.types.map(function(type) {
                                return {
                                    src: type.file.url,
                                    type: type.file.contentType
                                };
                            }),
                            tx: {
                                marginBottom: 80
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                    tx: {
                        maxWidth: 608,
                        marginX: "auto",
                        marginBottom: 40,
                        color: "pigeon200",
                        fontSize: "clamp(16px, 1.66vw, 24px)",
                        fontWeight: "medium",
                        textAlign: "center"
                    },
                    variant: "text-ui-24",
                    children: "Join the waitlist to access to Air\u2019s remote video collaboration system."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdobeWaitlistForm, {
                    tx: {
                        maxWidth: 504,
                        marginX: "auto"
                    }
                })
            ]
        })
    });
};
AdobeSplashCTASectionTemplate.templateKey = TEMPLATE_KEY;

// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/widont/index.js
var widont = __webpack_require__(19491);
var widont_default = /*#__PURE__*/__webpack_require__.n(widont);
// EXTERNAL MODULE: ./src/hooks/useRefScrollProgress.ts
var useRefScrollProgress = __webpack_require__(91143);
;// CONCATENATED MODULE: ./src/old-marketing/components/sections/AdobeSplashOverviewSectionTemplateFeaturedImage.tsx
function AdobeSplashOverviewSectionTemplateFeaturedImage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AdobeSplashOverviewSectionTemplateFeaturedImage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AdobeSplashOverviewSectionTemplateFeaturedImage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var AdobeSplashOverviewSectionTemplateFeaturedImage = function(param) {
    var tx = param.tx;
    var ref = (0,useRefScrollProgress/* useRefScrollProgress */.J)({
        offset: -0.1
    }), ref1 = ref.ref, start = ref.start, end = ref.end;
    var scrollYProgress = (0,framer_motion_es/* useViewportScroll */.ME)().scrollYProgress;
    var layer1XPos = (0,framer_motion_es/* useTransform */.Hm)(scrollYProgress, [
        start,
        end
    ], [
        400,
        0
    ]);
    var layer1XPosAnimation = (0,framer_motion_es/* useSpring */.q_)(layer1XPos, {
        stiffness: 200,
        damping: 20
    });
    var layer2XPos = (0,framer_motion_es/* useTransform */.Hm)(scrollYProgress, [
        start,
        end
    ], [
        -400,
        0
    ]);
    var layer2XPosAnimation = (0,framer_motion_es/* useSpring */.q_)(layer2XPos, {
        stiffness: 200,
        damping: 20
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
        tx: AdobeSplashOverviewSectionTemplateFeaturedImage_objectSpread({
            width: "100%",
            maxWidth: 1160
        }, tx),
        ref: ref1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
            tx: {
                position: "relative",
                pb: "51.9%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    as: framer_motion_es/* motion.div */.ww.div,
                    tx: {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: "69.8%"
                    },
                    style: {
                        x: layer1XPosAnimation
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        height: 603,
                        src: "/assets/marketing/adobe-splash-overview-template-layer-1.png",
                        width: 811
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    as: framer_motion_es/* motion.div */.ww.div,
                    tx: {
                        position: "absolute",
                        top: "9.1%",
                        left: 0,
                        width: "48.5%"
                    },
                    style: {
                        x: layer2XPosAnimation
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        height: 522.5,
                        src: "/assets/marketing/adobe-splash-overview-template-layer-2.png",
                        width: 564.5
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/old-marketing/components/sections/templates/AdobeSplashOverviewSectionTemplate.tsx










var AdobeSplashOverviewSectionTemplate_TEMPLATE_KEY = "adobe-splash-overview";
var AdobeSplashOverviewSectionTemplate = function(param) {
    var content = param.content, id = param.id, isSubsection = param.isSubsection, subsections = param.subsections, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$, {
        css: {
            paddingTop: 0,
            paddingBottom: 80
        },
        id: id,
        templateKey: AdobeSplashOverviewSectionTemplate_TEMPLATE_KEY,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                        tx: {
                            maxWidth: 780,
                            mx: "auto",
                            marginBottom: [
                                40,
                                156
                            ],
                            textAlign: "center"
                        },
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                                css: {
                                    marginBottom: 36,
                                    color: "$jay150"
                                },
                                isSubsection: isSubsection,
                                size: "heading-56",
                                children: widont_default()(title)
                            }),
                            content && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContent/* SectionContent */.ZG, {
                                content: content,
                                css: {
                                    color: "$pigeon200"
                                },
                                size: "ui-20"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdobeSplashOverviewSectionTemplateFeaturedImage, {
                        tx: {
                            marginBottom: [
                                80,
                                120
                            ]
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                tx: {
                    zIndex: -1,
                    position: "absolute",
                    top: "78vw",
                    left: "-170vw",
                    width: "362vw"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    height: 3502,
                    src: "/assets/marketing/adobe-splash-background-image-2.svg",
                    width: 3973
                })
            }),
            subsections === null || subsections === void 0 ? void 0 : subsections.map(function(subsection, index) {
                return sectionRenderer(subsection, index, true);
            })
        ]
    });
};
AdobeSplashOverviewSectionTemplate.templateKey = AdobeSplashOverviewSectionTemplate_TEMPLATE_KEY;

;// CONCATENATED MODULE: ./src/old-marketing/components/sections/templates/AdobeSplashTextWithVideoSectionTemplate.tsx









var AdobeSplashTextWithVideoSectionTemplate_TEMPLATE_KEY = "adobe-splash-text-with-video";
var AdobeSplashTextWithVideoSectionTemplate = function(param) {
    var content = param.content, id = param.id, isSubsection = param.isSubsection, title = param.title, videos = param.videos;
    var isPreview = (0,PreviewModeProvider/* usePreviewMode */.s)().isPreview;
    var video = videos === null || videos === void 0 ? void 0 : videos[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
        css: {
            paddingY: 80
        },
        id: id,
        templateKey: AdobeSplashTextWithVideoSectionTemplate_TEMPLATE_KEY,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                tx: {
                    mb: [
                        80,
                        156
                    ],
                    "&:last-child": {
                        mb: 0
                    }
                },
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                        css: {
                            maxWidth: 464,
                            marginBottom: 24,
                            marginX: "auto",
                            color: "$jay150",
                            textAlign: "center",
                            "@laptop": {
                                marginBottom: 40,
                                marginX: 0,
                                textAlign: "left"
                            }
                        },
                        dangerouslySetInnerHTML: {
                            __html: title
                        },
                        isSubsection: isSubsection,
                        size: "heading-40"
                    }),
                    content && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContent/* SectionContent */.ZG, {
                        content: content,
                        css: {
                            maxWidth: 560,
                            marginBottom: 40,
                            marginRight: "auto",
                            marginLeft: "auto",
                            color: "$pigeon200",
                            textAlign: "center",
                            "@laptop": {
                                marginRight: 0,
                                textAlign: "left"
                            }
                        },
                        size: "ui-20"
                    }),
                    video && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFieldTooltip/* SectionFieldTooltip */.B, {
                        field: "Videos",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
                                className: isPreview ? Section/* SECTION_CMS_LINK_CLASS_NAME */.l : "",
                                details: {
                                    height: video.height,
                                    width: video.width
                                },
                                poster: video.poster.file.url,
                                sources: video.types.map(function(type) {
                                    return {
                                        src: type.file.url,
                                        type: type.file.contentType
                                    };
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
AdobeSplashTextWithVideoSectionTemplate.templateKey = AdobeSplashTextWithVideoSectionTemplate_TEMPLATE_KEY;

// EXTERNAL MODULE: ./src/hooks/useGatedBySlug.ts
var useGatedBySlug = __webpack_require__(74455);
;// CONCATENATED MODULE: ./src/old-marketing/components/sections/templates/GatedBySlugSectionTemplate.tsx
function GatedBySlugSectionTemplate_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function GatedBySlugSectionTemplate_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function GatedBySlugSectionTemplate_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function GatedBySlugSectionTemplate_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function GatedBySlugSectionTemplate_slicedToArray(arr, i) {
    return GatedBySlugSectionTemplate_arrayWithHoles(arr) || GatedBySlugSectionTemplate_iterableToArrayLimit(arr, i) || GatedBySlugSectionTemplate_unsupportedIterableToArray(arr, i) || GatedBySlugSectionTemplate_nonIterableRest();
}
function GatedBySlugSectionTemplate_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return GatedBySlugSectionTemplate_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return GatedBySlugSectionTemplate_arrayLikeToArray(o, minLen);
}





var GatedBySlugSectionTemplate_TEMPLATE_KEY = "gated-by-slug";
var GatedBySlugSectionTemplate = function(param) {
    var id = param.id, subsections = param.subsections;
    var ref = GatedBySlugSectionTemplate_slicedToArray((0,useGatedBySlug/* useGatedBySlug */.g)(), 1), isGatedBySlug = ref[0];
    var ref1 = (0,react.useState)(false), isMounted = ref1[0], setIsMounted = ref1[1];
    (0,react.useEffect)(function() {
        setIsMounted(true);
        return function() {
            return setIsMounted(false);
        };
    }, []);
    if (!isMounted || isGatedBySlug) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
        id: id,
        templateKey: GatedBySlugSectionTemplate_TEMPLATE_KEY,
        css: {
            overflow: "visible"
        },
        children: subsections === null || subsections === void 0 ? void 0 : subsections.map(function(subsection, index) {
            return sectionRenderer(subsection, index, true);
        })
    });
};
GatedBySlugSectionTemplate.templateKey = GatedBySlugSectionTemplate_TEMPLATE_KEY;

// EXTERNAL MODULE: ../../packages/primitives/src/index.tsx + 20 modules
var primitives_src = __webpack_require__(89170);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
// EXTERNAL MODULE: ./src/old-marketing/components/globals/Container.tsx
var globals_Container = __webpack_require__(56083);
;// CONCATENATED MODULE: ./src/old-marketing/components/sections/templates/OperatorsSectionTemplate/components/Filters.tsx
function Filters_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Filters_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Filters_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Filters_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Filters_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Filters_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var FILTERS = [
    "Tech",
    "Consumer",
    "CPG",
    "Financial",
    "Media",
    "Agency",
    "Sports"
];
var Filters = function(_param) {
    var activeFilters = _param.activeFilters, onChangeFilter = _param.onChangeFilter, tx = _param.tx, restOfProps = Filters_objectWithoutProperties(_param, [
        "activeFilters",
        "onChangeFilter",
        "tx"
    ]);
    var ref;
    var numberOfFilters = (ref = activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length) !== null && ref !== void 0 ? ref : 0;
    var hasFilters = numberOfFilters > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, Filters_objectSpread({}, restOfProps, {
        tx: Filters_objectSpread({
            mx: "auto",
            mb: 64,
            textAlign: "center"
        }, tx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Button */.zx, {
                onClick: function() {
                    return onChangeFilter("all");
                },
                tx: {
                    backgroundColor: !hasFilters ? "macaw060" : "transparent",
                    mx: 12,
                    mb: 12,
                    borderColor: !hasFilters ? "transparent" : undefined
                },
                variant: "button-outline-blue",
                children: "All"
            }),
            FILTERS.map(function(filter) {
                var isActiveFilters = activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.includes(filter);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Button */.zx, {
                    onClick: function() {
                        return onChangeFilter(filter);
                    },
                    tx: {
                        backgroundColor: isActiveFilters ? "macaw060" : "transparent",
                        mr: 12,
                        mb: 12,
                        borderColor: isActiveFilters ? "transparent" : undefined,
                        "&:last-child": {
                            mr: 0
                        }
                    },
                    variant: "button-outline-blue",
                    children: filter
                }, filter);
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/old-marketing/components/sections/templates/OperatorsSectionTemplate/components/OperatorCard.styles.ts
function OperatorCard_styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var Avatar = (0,primitives_src/* styled */.zo)("div", {
    position: "relative",
    paddingBottom: "86%",
    filter: "grayscale(1)",
    transition: "filter 0.2s ease"
});
var Logo = (0,primitives_src/* styled */.zo)("div", {
    position: "relative",
    height: 16,
    marginTop: 4,
    marginBottom: 12,
    filter: "grayscale(1)",
    transition: "filter 0.2s ease"
});
var Root = (0,primitives_src/* styled */.zo)("a", {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "$pigeon025",
    borderRadius: 8,
    border: "1px solid $colors$pigeon050",
    textDecoration: "none",
    overflow: "hidden",
    transition: "box-shadow 0.2s ease",
    cursor: "pointer",
    "&:hover": OperatorCard_styles_defineProperty({
        boxShadow: "0 4px 4px rgba(0, 0, 0, 0.25)"
    }, "& ".concat(Avatar, ", & ").concat(Logo), {
        filter: "grayscale(0)"
    })
});
var Meta = (0,primitives_src/* styled */.zo)("div", {
    zIndex: 1,
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    backgroundColor: "$white",
    padding: 12,
    borderTop: "1px solid $colors$pigeon050"
});
var StyledOperatorCard = {
    Avatar: Avatar,
    Logo: Logo,
    Meta: Meta,
    Root: Root
};

// EXTERNAL MODULE: ./src/utils/contentfulImageLoader.ts
var contentfulImageLoader = __webpack_require__(49075);
;// CONCATENATED MODULE: ./src/old-marketing/components/sections/templates/OperatorsSectionTemplate/components/OperatorCard.tsx





var OperatorCard = function(param) {
    var avatar = param.avatar, logo = param.logo, name = param.name, title = param.title, _url = param.url, url = _url === void 0 ? "/" : _url;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOperatorCard.Root, {
        href: url,
        target: "_blank",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOperatorCard.Avatar, {
                children: avatar && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "fill",
                    loader: contentfulImageLoader/* contentfulImageLoader */._,
                    objectFit: "cover",
                    src: avatar.file.url
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOperatorCard.Meta, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOperatorCard.Logo, {
                        children: logo && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            loader: contentfulImageLoader/* contentfulImageLoader */._,
                            objectFit: "contain",
                            objectPosition: "left",
                            src: logo.file.url
                        })
                    }),
                    name && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Text */.xv, {
                        css: {
                            marginBottom: 4,
                            color: "$pigeon700",
                            fontWeight: "$medium"
                        },
                        size: "heading-16",
                        children: name
                    }),
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Text */.xv, {
                        css: {
                            color: "$pigeon500",
                            fontWeight: "$medium"
                        },
                        size: "ui-12",
                        children: title
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/old-marketing/components/sections/templates/OperatorsSectionTemplate/OperatorsSectionTemplate.tsx
function OperatorsSectionTemplate_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function OperatorsSectionTemplate_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            OperatorsSectionTemplate_defineProperty(target, key, source[key]);
        });
    }
    return target;
}













var OperatorsSectionTemplate_TEMPLATE_KEY = "operators";
var OperatorsSectionTemplate = function(param) {
    var logos = param.assets, content = param.content, id = param.id, operators1 = param.references, title = param.title;
    var ref = (0,react.useState)([]), filters = ref[0], setFilters = ref[1];
    var hasFilters = filters.length > 0;
    var filteredOperators = (0,react.useMemo)(function() {
        if (hasFilters && operators1) {
            return operators1 === null || operators1 === void 0 ? void 0 : operators1.filter(function(operator) {
                var hasMatch = false;
                if (operator.industry) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = operator.industry[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var industry = _step.value;
                            if ((0,lodash.includes)(filters, industry)) {
                                hasMatch = true;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return hasMatch;
            });
        }
        return operators1;
    }, [
        filters,
        hasFilters,
        operators1
    ]);
    var onChangeFilter = function(value) {
        if (value === "all") {
            setFilters([]);
        } else if ((0,lodash.includes)(filters, value)) {
            setFilters((0,lodash.without)(filters, value));
        } else {
            setFilters([
                value
            ]);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$, {
        css: {
            paddingTop: 72,
            paddingBottom: 108
        },
        id: id,
        templateKey: OperatorsSectionTemplate_TEMPLATE_KEY,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(globals_Container/* Container */.W, {
                css: {
                    maxWidth: 864,
                    textAlign: "center"
                },
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                        css: {
                            color: "$jay800",
                            marginBottom: 36
                        },
                        size: "heading-40",
                        children: title
                    }),
                    content && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContent/* SectionContent */.ZG, {
                        content: content
                    }),
                    logos && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Box */.xu, {
                        css: {
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            marginBottom: 64
                        },
                        children: logos.map(function(logo, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Box */.xu, {
                                css: {
                                    display: "flex",
                                    alignItems: "center",
                                    marginX: 16,
                                    marginBottom: 24
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    height: logo.file.details.image.height,
                                    // layout="fill"
                                    loader: contentfulImageLoader/* contentfulImageLoader */._,
                                    // objectFit="cover"
                                    src: logo.file.url,
                                    width: logo.file.details.image.width
                                })
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(globals_Container/* Container */.W, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters, {
                        activeFilters: filters,
                        onChangeFilter: onChangeFilter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Box */.xu, {
                        css: {
                            display: "grid",
                            gridTemplateColumns: "repeat(1, 1fr)",
                            gap: 32,
                            "@tablet": {
                                gridTemplateColumns: "repeat(2, 1fr)"
                            },
                            "@laptop": {
                                gridTemplateColumns: "repeat(4, 1fr)"
                            }
                        },
                        children: filteredOperators === null || filteredOperators === void 0 ? void 0 : filteredOperators.map(function(operators) {
                            return /*#__PURE__*/ (0,react.createElement)(OperatorCard, OperatorsSectionTemplate_objectSpread({}, operators, {
                                key: operators.id
                            }));
                        })
                    })
                ]
            })
        ]
    });
};
OperatorsSectionTemplate.templateKey = OperatorsSectionTemplate_TEMPLATE_KEY;

// EXTERNAL MODULE: ./src/old-marketing/components/sections/templates/worthless-studios/theme.ts
var theme = __webpack_require__(47016);
;// CONCATENATED MODULE: ./src/old-marketing/components/sections/templates/worthless-studios/WorthlessStudiosAboutSectionTemplate.tsx









var WorthlessStudiosAboutSectionTemplate_TEMPLATE_KEY = "worthless-studios-about";
var WorthlessStudiosAboutSectionTemplate = function(param) {
    var assets = param.assets, content = param.content, id = param.id, isPreview = param.isPreview, isSubsection = param.isSubsection, title = param.title;
    var film1 = assets === null || assets === void 0 ? void 0 : assets[0];
    var film2 = assets === null || assets === void 0 ? void 0 : assets[1];
    var film3 = assets === null || assets === void 0 ? void 0 : assets[2];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
        className: theme/* worthlessStudiosTheme */.b,
        css: {
            paddingTop: 286,
            paddingBottom: 60,
            overflow: "visible",
            "@laptop": {
                paddingTop: 106
            }
        },
        id: id,
        templateKey: WorthlessStudiosAboutSectionTemplate_TEMPLATE_KEY,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                        tx: {
                            position: "absolute",
                            left: [
                                -294,
                                "calc(clamp(0px, 26.25vw, 378px) * -1)"
                            ],
                            top: [
                                -80,
                                "50%"
                            ],
                            width: [
                                588.6,
                                "clamp(0px, 65.2vw, 939px)"
                            ],
                            transform: [
                                "none",
                                "translateY(-50%)"
                            ]
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                            tx: {
                                position: "relative",
                                paddingBottom: "52.6%"
                            },
                            children: [
                                film3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFieldTooltip/* SectionFieldTooltip */.B, {
                                    isPreview: isPreview,
                                    field: "Asset (2)",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                                        tx: {
                                            position: "absolute",
                                            top: "58.2%",
                                            left: "23.2%",
                                            width: "80%",
                                            transform: "rotate(6.77deg)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            height: film3.file.details.image.height,
                                            src: "http:".concat(film3.file.url),
                                            width: film3.file.details.image.width
                                        })
                                    })
                                }),
                                film2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFieldTooltip/* SectionFieldTooltip */.B, {
                                    isPreview: isPreview,
                                    field: "Asset (2)",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                                        tx: {
                                            position: "absolute",
                                            top: "35.4%",
                                            left: "21.2%",
                                            width: "80%",
                                            transform: "rotate(-22.77deg)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            height: film2.file.details.image.height,
                                            src: "http:".concat(film2.file.url),
                                            width: film2.file.details.image.width
                                        })
                                    })
                                }),
                                film1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFieldTooltip/* SectionFieldTooltip */.B, {
                                    isPreview: isPreview,
                                    field: "Asset (1)",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                                        tx: {
                                            position: "absolute",
                                            top: "22.8%",
                                            left: "-2.2%",
                                            width: "80%",
                                            transform: "rotate(-25.83deg)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            height: film1.file.details.image.height,
                                            src: "http:".concat(film1.file.url),
                                            width: film1.file.details.image.width
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                    tx: {
                        width: [
                            "100%",
                            "58%"
                        ],
                        marginLeft: [
                            0,
                            "42%"
                        ],
                        paddingRight: [
                            0,
                            "max(2.7vw, 40px)"
                        ]
                    },
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                            css: {
                                marginBottom: 32,
                                color: "$pigeon800",
                                textAlign: "left",
                                "@laptop": {
                                    textAlign: "right"
                                }
                            },
                            isSubsection: isSubsection,
                            size: "heading-48",
                            children: title
                        }),
                        content && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContent/* SectionContent */.ZG, {
                            content: content,
                            css: {
                                color: "$pigeon600",
                                letterSpacing: 0.05,
                                lineHeight: 1.6,
                                textAlign: "left",
                                "@laptop": {
                                    textAlign: "right"
                                }
                            }
                        })
                    ]
                })
            ]
        })
    });
};
WorthlessStudiosAboutSectionTemplate.templateKey = WorthlessStudiosAboutSectionTemplate_TEMPLATE_KEY;

// EXTERNAL MODULE: ./src/old-marketing/utils/buttonLinkRenderer.tsx
var buttonLinkRenderer = __webpack_require__(78214);
// EXTERNAL MODULE: ../../node_modules/@air/icons/dist/icons.esm.js
var icons_esm = __webpack_require__(74398);
// EXTERNAL MODULE: ./src/old-marketing/components/Link.tsx
var Link = __webpack_require__(25017);
;// CONCATENATED MODULE: ./src/old-marketing/utils/linkRenderer.tsx
function linkRenderer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function linkRenderer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            linkRenderer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function linkRenderer_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = linkRenderer_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function linkRenderer_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var linkRenderer = function(_param) {
    var analytics = _param.analytics, children = _param.children, href = _param.href, id = _param.id, type = _param.type, tx = _param.tx, restOfProps = linkRenderer_objectWithoutProperties(_param, [
        "analytics",
        "children",
        "href",
        "id",
        "type",
        "tx"
    ]);
    var isInternalUrl = type === "internal";
    var isLinkTo = href.charAt(0) === "#" && href.length > 1;
    if (!isInternalUrl) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* ExternalLink */.d, linkRenderer_objectSpread({
        analytics: linkRenderer_objectSpread({
            destination: href,
            destinationType: "external",
            name: children
        }, analytics),
        href: href,
        tx: tx
    }, restOfProps, {
        children: children
    }), id);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* InternalLink */.h, linkRenderer_objectSpread({
        analytics: linkRenderer_objectSpread({
            destination: href,
            destinationType: "internal"
        }, analytics),
        href: href,
        onClick: isLinkTo ? function(event) {
            var ref;
            event.preventDefault();
            (ref = document === null || document === void 0 ? void 0 : document.getElementById(href.substr(1))) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                behavior: "smooth"
            });
        } : lodash.noop,
        tx: linkRenderer_objectSpread({}, isLinkTo ? {
            display: "flex",
            alignItems: "center",
            flexDirection: "column"
        } : {}, tx)
    }, restOfProps, {
        children: [
            children,
            isLinkTo && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                as: framer_motion_es/* motion.div */.ww.div,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    as: icons_esm/* DoubleChevronDown */.STg,
                    tx: {
                        width: 40
                    }
                })
            })
        ]
    }), id);
};


;// CONCATENATED MODULE: ./src/old-marketing/utils/actionsRenderer.ts



var actionsRenderer = function(actions) {
    return actions.map(function(action) {
        var isLink = action.__typename === ContentTypes.components.link;
        if (isLink) {
            return linkRenderer({
                analytics: {
                    name: action.text
                },
                id: action.id,
                children: action.text,
                href: action.url,
                tx: {
                    mr: 8
                },
                type: action.type
            });
        }
        return (0,buttonLinkRenderer/* buttonLinkRenderer */.w)({
            analytics: {
                name: action.text
            },
            children: action.text,
            href: action.url,
            id: action.id,
            size: action.size,
            tx: {
                mr: 8
            },
            type: action.type,
            /** @ts-ignore temporary until we convert all marketing views to use the newest version of the parser */ variant: action.variant
        });
    });
};

;// CONCATENATED MODULE: ./src/old-marketing/components/sections/SectionActions.tsx






var SectionActions = function(param) {
    var actions = param.actions, css = param.css, isCMSLinked = param.isCMSLinked;
    var isPreview = (0,PreviewModeProvider/* usePreviewMode */.s)().isPreview;
    var element = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Box */.xu, {
        className: isPreview ? Section/* SECTION_CMS_LINK_CLASS_NAME */.l : "",
        css: css,
        children: actionsRenderer(actions)
    });
    return isCMSLinked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFieldTooltip/* SectionFieldTooltip */.B, {
        field: "Actions",
        children: element
    }) : element;
};

;// CONCATENATED MODULE: ./src/old-marketing/components/sections/templates/worthless-studios/WorthlessStudiosCTASectionTemplate.tsx





var WorthlessStudiosCTASectionTemplate_TEMPLATE_KEY = "worthless-studios-cta";
var WorthlessStudiosCTASectionTemplate = function(param) {
    var actions = param.actions, backgroundImages = param.backgroundImages, id = param.id, isSubsection = param.isSubsection, title = param.title;
    var backgroundImage = backgroundImages === null || backgroundImages === void 0 ? void 0 : backgroundImages[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
        css: {
            backgroundColor: "$pigeon800",
            backgroundImage: 'url("'.concat(backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.file.url, '")'),
            backgroundSize: "cover",
            paddingY: 92
        },
        id: id,
        templateKey: WorthlessStudiosCTASectionTemplate_TEMPLATE_KEY,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                    css: {
                        marginBottom: 32,
                        color: "$white",
                        textAlign: "center"
                    },
                    isSubsection: isSubsection,
                    size: "heading-48",
                    children: title
                }),
                actions && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionActions, {
                    actions: actions,
                    css: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "stretch",
                        a: {
                            minWidth: 248,
                            "&:last-child": {
                                marginTop: 24,
                                marginLeft: 0,
                                color: "$pigeon300"
                            }
                        },
                        "@laptop": {
                            flexDirection: "row",
                            justifyContent: "center",
                            a: {
                                "&:last-child": {
                                    marginTop: 0,
                                    marginLeft: 32
                                }
                            }
                        }
                    }
                })
            ]
        })
    });
};
WorthlessStudiosCTASectionTemplate.templateKey = WorthlessStudiosCTASectionTemplate_TEMPLATE_KEY;

;// CONCATENATED MODULE: ./src/old-marketing/components/sections/templates/worthless-studios/WorthlessStudiosEmbeddedBoardsTemplate.tsx







var WorthlessStudiosEmbeddedBoardsTemplate_TEMPLATE_KEY = "worthless-studios-embedded-boards";
var WorthlessStudiosEmbeddedBoardsTemplate = function(param) {
    var additionalSettings = param.additionalSettings, id = param.id, isSubsection = param.isSubsection, title = param.title;
    var iframeRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (iframeRef === null || iframeRef === void 0 ? void 0 : iframeRef.current) {
            iframeRef.current.addEventListener("load", function() {
                var ref, ref1, ref2, ref3;
                var style = document.createElement("style");
                style.appendChild(document.createTextNode('\n            .ReactVirtualized__List { padding-bottom: 0 !important; }\n            [data-testid="list-section-title"] {\n              display: none;\n            }\n            [data-testid="banner-container"] {\n              display: none;\n            }\n            [data-testid="PUBLIC_BOARD_CHILDREN_CONTAINER"] {\n              margin-right: 0 !important;\n            }\n            [data-testid="JOIN_BANNER"] {\n              display: none;\n            }\n            [data-testid="PUBLIC_BOARD_SIDE_NAV"] {\n              display: none;\n            }\n            [data-testid="VIEW_CONTROLS"] {\n              display: none;\n            }\n            [data-testid="BOARD_BLURB_TITLE"] {\n              display: none;\n            }\n            [data-testid="BOARD_BLURB_DESCRIPTION"] {\n              display: none;\n            }\n            [data-testid="WORKSPACE_STICKY_HEADER_CONTAINER"] {\n              display: none;\n            }\n          '));
                iframeRef === null || iframeRef === void 0 ? void 0 : (ref = iframeRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.document) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.head) === null || ref3 === void 0 ? void 0 : ref3.appendChild(style);
            });
        }
    }, [
        iframeRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
        className: theme/* worthlessStudiosTheme */.b,
        css: {
            paddingTop: 60,
            paddingBottom: 60,
            overflow: "visible"
        },
        id: id,
        templateKey: WorthlessStudiosEmbeddedBoardsTemplate_TEMPLATE_KEY,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                    css: {
                        marginBottom: 32,
                        color: "$pigeon800",
                        textAlign: "center"
                    },
                    isSubsection: isSubsection,
                    size: "heading-56",
                    children: title
                }),
                (additionalSettings === null || additionalSettings === void 0 ? void 0 : additionalSettings.airPublicBoardUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    as: "iframe",
                    ref: iframeRef,
                    src: additionalSettings.airPublicBoardUrl,
                    title: "Air public board",
                    tx: {
                        width: "100%",
                        height: 700,
                        maxHeight: "80vh",
                        border: 0
                    }
                })
            ]
        })
    });
};
WorthlessStudiosEmbeddedBoardsTemplate.templateKey = WorthlessStudiosEmbeddedBoardsTemplate_TEMPLATE_KEY;

;// CONCATENATED MODULE: ./src/old-marketing/components/sections/templates/worthless-studios/WorthlessStudiosOurProjectsTemplate.tsx










var WorthlessStudiosOurProjectsTemplate_TEMPLATE_KEY = "worthless-studios-our-projects";
var WorthlessStudiosOurProjectsSectionTemplate = function(param) {
    var actions = param.actions, assets = param.assets, content = param.content, id = param.id, isPreview = param.isPreview, isSubsection = param.isSubsection, title = param.title;
    var asset = assets === null || assets === void 0 ? void 0 : assets[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
        className: theme/* worthlessStudiosTheme */.b,
        css: {
            paddingTop: 60,
            paddingBottom: 60,
            overflow: "visible"
        },
        id: id,
        templateKey: WorthlessStudiosOurProjectsTemplate_TEMPLATE_KEY,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            tx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                    tx: {
                        width: [
                            "100%",
                            "50%"
                        ],
                        maxWidth: 527,
                        mr: [
                            0,
                            32
                        ],
                        ml: [
                            0,
                            "max(3.8vw, 56px)"
                        ]
                    },
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                            css: {
                                marginBottom: 32,
                                colorr: "$pigeon800"
                            },
                            isSubsection: isSubsection,
                            size: "heading-48",
                            children: title
                        }),
                        content && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContent/* SectionContent */.ZG, {
                            content: content,
                            css: {
                                color: "$pigeon600",
                                letterSpacing: 0.05,
                                lineHeight: 1.6
                            },
                            size: "ui-20"
                        }),
                        actions && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionActions, {
                            actions: actions,
                            css: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "stretch",
                                marginTop: 40,
                                a: {
                                    marginBottom: 24,
                                    marginRight: 0
                                },
                                "@laptop": {
                                    flexDirection: "row",
                                    justifyContent: "flex-start",
                                    a: {
                                        marginBottom: 0,
                                        marginRight: 12
                                    }
                                }
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    tx: {
                        display: [
                            "none",
                            "block"
                        ],
                        width: "50%",
                        maxWidth: 490,
                        mr: 56
                    },
                    children: asset && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFieldTooltip/* SectionFieldTooltip */.B, {
                        field: "Assets (1)",
                        isPreview: isPreview,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            height: asset.file.details.image.height,
                            src: "http:".concat(asset.file.url),
                            width: asset.file.details.image.width
                        })
                    })
                })
            ]
        })
    });
};
WorthlessStudiosOurProjectsSectionTemplate.templateKey = WorthlessStudiosOurProjectsTemplate_TEMPLATE_KEY;

// EXTERNAL MODULE: ./src/utils/clamp.ts + 1 modules
var clamp = __webpack_require__(5808);
;// CONCATENATED MODULE: ./src/old-marketing/components/sections/SectionLabel.tsx
function SectionLabel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SectionLabel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SectionLabel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var TEXT_SIZE_CSS = {
    "ui-16": {
        fontSize: (0,clamp/* clamp */.u)(14, 16)
    },
    "ui-14": {
        fontSize: (0,clamp/* clamp */.u)(12, 14)
    }
};
var TEXT_SIZE_VARIANTS = {
    "ui-16": {
        desktop: "ui-16",
        mobile: "ui-14"
    },
    "ui-14": {
        desktop: "ui-14",
        mobile: "ui-12"
    }
};
var SectionLabel = function(param) {
    var children = param.children, css = param.css, _isCMSLinked = param.isCMSLinked, isCMSLinked = _isCMSLinked === void 0 ? true : _isCMSLinked, _size = param.size, size = _size === void 0 ? "ui-16" : _size, _transform = param.transform, transform = _transform === void 0 ? "uppercase" : _transform;
    var isPreview = (0,PreviewModeProvider/* usePreviewMode */.s)().isPreview;
    var element = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Text */.xv, {
        className: isPreview && isCMSLinked ? Section/* SECTION_CMS_LINK_CLASS_NAME */.l : "",
        css: SectionLabel_objectSpread({}, TEXT_SIZE_CSS[size], css),
        size: {
            "@initial": TEXT_SIZE_VARIANTS[size].mobile,
            "@desktop": TEXT_SIZE_VARIANTS[size].desktop
        },
        transform: transform,
        children: children
    });
    return isCMSLinked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFieldTooltip/* SectionFieldTooltip */.B, {
        field: "Label",
        children: element
    }) : element;
};

;// CONCATENATED MODULE: ./src/old-marketing/components/sections/templates/WorthlessStudiosFreeFilmsSectionTemplate/WorthlessStudiosFreeFilmsSectionTemplateAsset.tsx
function WorthlessStudiosFreeFilmsSectionTemplateAsset_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function WorthlessStudiosFreeFilmsSectionTemplateAsset_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            WorthlessStudiosFreeFilmsSectionTemplateAsset_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var WorthlessStudiosFreeFilmsSectionTemplateAsset = function(param) {
    var file = param.file, isPreview = param.isPreview, tx = param.tx;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
        className: isPreview ? Section/* SECTION_CMS_LINK_CLASS_NAME */.l : "",
        tx: WorthlessStudiosFreeFilmsSectionTemplateAsset_objectSpread({
            position: "relative",
            maxWidth: [
                274,
                "25vw"
            ],
            mt: [
                90,
                -70
            ],
            transform: [
                "rotate(8deg)",
                "none"
            ],
            "> span": {
                display: "block !important",
                borderRadius: 4
            }
        }, tx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                tx: {
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    border: "1px solid",
                    borderColor: "pigeon800",
                    borderRadius: 4,
                    transform: "translate(-17.8%, -13.4%)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                tx: {
                    position: "absolute",
                    backgroundColor: [
                        "pigeon050",
                        "white"
                    ],
                    width: "100%",
                    height: "100%",
                    border: "1px solid",
                    borderColor: "pigeon800",
                    borderRadius: 4,
                    transform: "translate(-8.9%, -6.7%)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                height: file.details.image.height,
                src: "http:".concat(file.url),
                width: file.details.image.width
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/old-marketing/components/sections/templates/WorthlessStudiosFreeFilmsSectionTemplate/WorthlessStudiosFreeFilmsSectionTemplate.tsx
function WorthlessStudiosFreeFilmsSectionTemplate_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function WorthlessStudiosFreeFilmsSectionTemplate_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            WorthlessStudiosFreeFilmsSectionTemplate_defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var WorthlessStudiosFreeFilmsSectionTemplate_TEMPLATE_KEY = "worthless-studios-free-films";
var WorthlessStudiosFreeFilmsSectionTemplate = function(param) {
    var assets = param.assets, content = param.content, id = param.id, isPreview = param.isPreview, isSubsection = param.isSubsection, label = param.label, title = param.title;
    var asset = assets === null || assets === void 0 ? void 0 : assets[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$, {
        className: theme/* worthlessStudiosTheme */.b,
        css: {
            backgroundColor: "$pigeon050",
            paddingTop: 208,
            paddingBottom: 64,
            "@laptop": {
                paddingTop: "11vw",
                paddingBottom: 56
            }
        },
        id: id,
        templateKey: WorthlessStudiosFreeFilmsSectionTemplate_TEMPLATE_KEY,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                tx: {
                    position: "absolute",
                    top: 0,
                    backgroundImage: "linear-gradient(175deg, white 50%, #EFEFEF 50%)",
                    width: "100%",
                    height: "11vw"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                tx: {
                    display: "flex",
                    alignItems: "center",
                    flexDirection: [
                        "column",
                        "row"
                    ],
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                        tx: {
                            order: [
                                2,
                                1
                            ],
                            width: [
                                "100%",
                                "42%"
                            ],
                            display: "flex",
                            justifyContent: "flex-end",
                            paddingRight: 24
                        },
                        children: asset && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFieldTooltip/* SectionFieldTooltip */.B, {
                            field: "Asset (1)",
                            isPreview: isPreview,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WorthlessStudiosFreeFilmsSectionTemplateAsset, WorthlessStudiosFreeFilmsSectionTemplate_objectSpread({}, asset, {
                                isPreview: isPreview
                            }))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                        tx: {
                            order: [
                                1,
                                2
                            ],
                            width: [
                                "100%",
                                "58%"
                            ],
                            maxWidth: 664,
                            marginRight: 32,
                            paddingLeft: 32
                        },
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                                css: {
                                    color: "$pigeon800"
                                },
                                isSubsection: isSubsection,
                                size: "heading-48",
                                children: title
                            }),
                            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLabel, {
                                css: {
                                    color: "$pigeon800",
                                    letterSpacing: "-0.017em"
                                },
                                size: "ui-16",
                                children: label
                            }),
                            content && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContent/* SectionContent */.ZG, {
                                content: content,
                                css: {
                                    marginTop: 32,
                                    color: "$pigeon800",
                                    letterSpacing: "-0.017em",
                                    lineHeight: "26px"
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
WorthlessStudiosFreeFilmsSectionTemplate.templateKey = WorthlessStudiosFreeFilmsSectionTemplate_TEMPLATE_KEY;

// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(20204);
// EXTERNAL MODULE: ./src/old-marketing/components/Section.tsx
var components_Section = __webpack_require__(32999);
;// CONCATENATED MODULE: ./src/old-marketing/components/sections/TextSection.tsx









var TextSection = function(param) {
    var __typename = param.__typename, actions = param.actions, alignment = param.alignment, backgroundColor = param.backgroundColor, backgroundImage = param.backgroundImage, content = param.content, contentTitle = param.contentTitle, id = param.id, index = param.index, isSubsection = param.isSubsection, maxWidth = param.maxWidth, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Section/* Section */.$, {
        analytics: {
            contentId: id,
            contentTitle: contentTitle,
            contentType: __typename
        },
        id: "".concat(__typename, "-").concat(id, "-").concat(index),
        index: index,
        tx: {
            backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : null,
            backgroundImage: backgroundImage ? "url(".concat(backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.file.url, ")") : null,
            backgroundPosition: "top center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%",
            textAlign: alignment !== null && alignment !== void 0 ? alignment : null,
            py: isSubsection ? [
                32,
                32,
                32
            ] : [
                64,
                64,
                80
            ]
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                tx: {
                    maxWidth: maxWidth,
                    mx: "auto"
                },
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                        as: isSubsection ? "h3" : "h2",
                        tx: {
                            color: "jay700",
                            fontWeight: "semibold"
                        },
                        variant: [
                            "text-heading-32",
                            "text-heading-32",
                            "text-heading-40"
                        ],
                        children: widont_default()(title)
                    }),
                    content && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                        tx: {
                            color: "pigeon700",
                            mt: 32
                        },
                        variant: [
                            "text-ui-16",
                            "text-ui-16",
                            "text-ui-18"
                        ],
                        children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(content)
                    }),
                    actions && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                        tx: {
                            mt: 32
                        },
                        children: actions.map(function(action) {
                            var isLink = action.__typename === ContentTypes.components.link;
                            if (isLink) {
                                return linkRenderer({
                                    analytics: {
                                        name: action.text,
                                        section: {
                                            contentId: id,
                                            contentTitle: contentTitle,
                                            contentType: __typename
                                        }
                                    },
                                    children: action.text,
                                    href: action.url,
                                    tx: {
                                        mx: 8
                                    },
                                    type: action.type
                                });
                            }
                            return (0,buttonLinkRenderer/* buttonLinkRenderer */.w)({
                                analytics: {
                                    name: action.text,
                                    section: {
                                        contentId: id,
                                        contentTitle: contentTitle,
                                        contentType: __typename
                                    }
                                },
                                children: action.text,
                                href: action.url,
                                size: action.size,
                                tx: {
                                    mr: 8
                                },
                                type: action.type,
                                /** @ts-ignore temporary until we convert all marketing views to use the newest version of the parser */ variant: action.variant
                            });
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/old-marketing/utils/sectionRenderer.tsx
function sectionRenderer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sectionRenderer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sectionRenderer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}













var sectionRenderer = function(section, index, isSubsection) {
    if (section.__typename === "section") {
        switch(section.template){
            case AdobeSplashCTASectionTemplate.templateKey:
                return /*#__PURE__*/ (0,react.createElement)(AdobeSplashCTASectionTemplate, sectionRenderer_objectSpread({}, section, {
                    isSubsection: isSubsection,
                    key: section.id
                }));
            case AdobeSplashOverviewSectionTemplate.templateKey:
                return /*#__PURE__*/ (0,react.createElement)(AdobeSplashOverviewSectionTemplate, sectionRenderer_objectSpread({}, section, {
                    isSubsection: isSubsection,
                    key: section.id
                }));
            case AdobeSplashTextWithVideoSectionTemplate.templateKey:
                return /*#__PURE__*/ (0,react.createElement)(AdobeSplashTextWithVideoSectionTemplate, sectionRenderer_objectSpread({}, section, {
                    isSubsection: isSubsection,
                    key: section.id
                }));
            case GatedBySlugSectionTemplate.templateKey:
                return /*#__PURE__*/ (0,react.createElement)(GatedBySlugSectionTemplate, sectionRenderer_objectSpread({}, section, {
                    key: section.id
                }));
            case OperatorsSectionTemplate.templateKey:
                return /*#__PURE__*/ (0,react.createElement)(OperatorsSectionTemplate, sectionRenderer_objectSpread({}, section, {
                    key: section.id
                }));
            case WorthlessStudiosAboutSectionTemplate.templateKey:
                return /*#__PURE__*/ (0,react.createElement)(WorthlessStudiosAboutSectionTemplate, sectionRenderer_objectSpread({}, section, {
                    isSubsection: isSubsection,
                    key: section.id
                }));
            case WorthlessStudiosCTASectionTemplate.templateKey:
                return /*#__PURE__*/ (0,react.createElement)(WorthlessStudiosCTASectionTemplate, sectionRenderer_objectSpread({}, section, {
                    isSubsection: isSubsection,
                    key: section.id
                }));
            case WorthlessStudiosEmbeddedBoardsTemplate.templateKey:
                return /*#__PURE__*/ (0,react.createElement)(WorthlessStudiosEmbeddedBoardsTemplate, sectionRenderer_objectSpread({}, section, {
                    isSubsection: isSubsection,
                    key: section.id
                }));
            case WorthlessStudiosFreeFilmsSectionTemplate.templateKey:
                return /*#__PURE__*/ (0,react.createElement)(WorthlessStudiosFreeFilmsSectionTemplate, sectionRenderer_objectSpread({}, section, {
                    isSubsection: isSubsection,
                    key: section.id
                }));
            case WorthlessStudiosOurProjectsSectionTemplate.templateKey:
                return /*#__PURE__*/ (0,react.createElement)(WorthlessStudiosOurProjectsSectionTemplate, sectionRenderer_objectSpread({}, section, {
                    isSubsection: isSubsection,
                    key: section.id
                }));
        }
    }
    switch(section.__typename){
        case ContentTypes.sections.shared.text:
            return /*#__PURE__*/ (0,react.createElement)(TextSection, sectionRenderer_objectSpread({}, section, {
                index: index,
                isSubsection: isSubsection,
                key: section.id
            }));
    }
};


/***/ }),

/***/ 49075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ contentfulImageLoader; }
/* harmony export */ });
var contentfulImageLoader = function(param) {
    var quality = param.quality, src = param.src, width = param.width;
    return "https:".concat(src, "?w=").concat(width, "&q=").concat(quality || 75);
};


/***/ })

}]);